module.exports = __webpack_public_path__ + "static/media/logo.1b8e88f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 1532
// module chunks = 0